import React from "react"
import {FortuneContents,} from "src/styles/views/UserPage/Fortune"
import BirthFortuneSearch from "src/component/UserPage/Fortune/BirthDayFortune/BirthFortuneSearch"
import {useRecoilValue, useResetRecoilState} from "recoil"
import {FortuneResultData, TimeOfBirthState} from "src/store/UserPage/fortune"
import BirthFortuneResult from "src/component/UserPage/Fortune/BirthDayFortune/BirthFortuneResult"
import {CustomBtn} from "src/styles/common/CommonForm/buttonform"
import {COLOR} from "src/service/constant/color"
import useWindowDimensions from "src/hooks/useGetWindowSize"

const BirthDayFortune = () => {
    const {width} = useWindowDimensions()
    const UserFortuneData = useRecoilValue(FortuneResultData)
    const ResetUserFortuneData = useResetRecoilState(FortuneResultData)
    const ResetUserBirthData = useResetRecoilState(TimeOfBirthState)
    return (
        <>
            <FortuneContents paddingBottom={UserFortuneData?.length === 0 ? "63px" : (width > 1200 ? "37px" : '29px')}>
                {UserFortuneData?.length === 0 ?
                    <BirthFortuneSearch/> : <BirthFortuneResult/>
                }
            </FortuneContents>
            {UserFortuneData?.length !== 0 &&
                <CustomBtn
                    color={COLOR.point1}
                    bgColor={COLOR.white}
                    borderColor={COLOR.point1}
                    borderRadius={"40px"}
                    marginTop={width > 600 ? "36px" : "24px"}
                    width={width > 600 ? "356px" : "328px"}
                    height={width > 600 ? "56px" : "44px"}
                    fontSize={width > 600 ? "18px" : "14px"}
                    fontFamily={width > 600 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                    onClick={() => {
                        ResetUserFortuneData()
                        ResetUserBirthData()
                    }}
                >
                    <span>다시 입력하기</span>
                </CustomBtn>
            }
        </>
    )
}
export default BirthDayFortune